/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TCreatePersonalMessageRequest,
  TCreatePersonalMessageModel,
  IMappers,
  TCreatePersonalMessageResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IPersonalMessageCreatorResult } from '../../entities/creator_result_personal_message/PersonalMessageCreatorResult';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createCreatePersonalMessageModel(
  parameters: TCreatePersonalMessageRequest,
): TCreatePersonalMessageModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'demand',
    pathApi: '/v2/create-personal-message/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ICreatePersonalMessageOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TCreatePersonalMessageRequest;
}

export async function fetchCreatePersonalMessage<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICreatePersonalMessageOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TCreatePersonalMessageResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createCreatePersonalMessageModel(parameters),
    config,
  )) as FetchResponse<TCreatePersonalMessageResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPersonalMessageCreatorResult, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TCreatePersonalMessageResponse>;
}
